import React, { useEffect, useState } from 'react';
import constantes from '../../resources/constantes.json';
import { useSetPage } from '../../contexts/pageContext';
/**
 * Se encarga de hacer fetch de los datos necesarios y cambiar el estado de la aplicación
 * según estemos en una página de estadísticas
 */

const GetStatsData = ({ page }) => {
  const [elec, setElec] = useState(1);
  const eleccion = constantes.nomAmbitos[constantes.nombreEleccion[elec]];
  const [tipoEst, setTipoEst] = useState('R');
  const [tipoDato, setTipoDato] = useState('PA');
  let dataUrl =
    '/json/ACT/' +
    eleccion +
    '/' +
    constantes.prefijos.estadisticas +
    tipoEst +
    tipoDato +
    '.json';

  const initialUrlInfo = React.useMemo(
    () => ({
      elec,
      tipoEst,
      tipoDato,
      page,
      setElec,
      setTipoEst,
      setTipoDato,
    }),
    [elec, tipoEst, tipoDato, page]
  );

  const setPage = useSetPage();

  useEffect(() => {
    setPage(dataUrl, initialUrlInfo);
  }, [dataUrl, initialUrlInfo, setPage]);
  return null;
};

export default GetStatsData;
